export const GET_PRODUCTS =  'GET_PRODUCTS';